<!-- 气象站主页 -->
<template>
    <div class='bg'>
        <el-row>
            <el-col :span="24" :offset="0">
                气象站选择：
                <el-select v-model="selWsId" placeholder="请选择" @change="changeWsta">
                    <el-option v-for="item in options" :key="item.wsId" :label="item.wsName" :value="item.wsId">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <!-- 实时数据 -->
        <el-row :gutter="20">
            <el-col :span="12" :offset="0">
                <StaGis :center="center" />
            </el-col>
            <el-col :span="12" :offset="0" class="nowBox">
                <el-row :gutter="20">
                    <el-col :span="12" :offset="0">
                        <el-card>
                            <div slot="header">
                                <span style="font-weight: 600;">实时温度</span>
                            </div>
                            <div class="rtdBox">
                                <img src="@/assets/images/wendu.svg" alt="wendu">
                                <span class="rtd">
                                    {{ rtdData.wendu }}
                                </span>
                                <span class="rtdUnit">℃</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="12" :offset="0">
                        <el-card>
                            <div slot="header">
                                <span style="font-weight: 600;">实时湿度</span>
                            </div>
                            <div class="rtdBox">
                                <img src="@/assets/images/shidu.svg" alt="shidu">
                                <span class="rtd">
                                    {{ rtdData.shidu }}
                                </span>
                                <span class="rtdUnit">%</span>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12" :offset="0">
                        <el-card>
                            <div slot="header">
                                <span style="font-weight: 600;">实时辐射</span>
                            </div>
                            <div class="rtdBox">
                                <img src="@/assets/images/fushe.svg" alt="fushe">
                                <span class="rtd">
                                    {{ rtdData.fushe }}
                                </span>
                                <span class="rtdUnit"></span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="12" :offset="0">
                        <el-card>
                            <div slot="header">
                                <span style="font-weight: 600;">实时风速</span>
                            </div>
                            <div class="rtdBox">
                                <img src="@/assets/images/fengsu.svg" alt="fengsu">
                                <span class="rtd">
                                    {{ rtdData.fengsu }}
                                </span>
                                <span class="rtdUnit">m/s</span>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>

        <!-- 日平均温度柱形图 -->
        <el-row>
            <el-col :span="24" :offset="0">
                <el-card>
                    <div slot="header">
                        <span>今日温度</span>
                    </div>
                    <div id="dayAvgChart" style="height: 300px;"></div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 数据曲线 -->
        <el-row>
            <el-col :span="24" :offset="0">
                <el-card>
                    <div slot="header">
                        <span>数据曲线</span>
                    </div>
                    <div id="dataChart" style="height: 300px;"></div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 报表 -->
        <el-row :gutter="20">
            <!-- 分钟报表 -->
            <el-col :span="12" :offset="0">
                <el-row>
                    <el-col :span="24" :offset="0">
                        <el-card>
                            <div slot="header">
                                分钟报表
                                <el-date-picker v-model="minTime" type="date" placeholder="选择日期" size="mini"
                                    value-format="yyyy-MM-dd" :clearable="false">
                                </el-date-picker>
                                <el-button type="primary" size="mini" style="margin-left: 10px;" @click="getMinReport"
                                    :disabled="buttonClick"><i class="el-icon-search"></i>搜索</el-button>
                                <el-button type="warning" size="mini" style="margin-left: 10px;" @click="exportMinReport"
                                    :disabled="buttonClick"><i class="el-icon-download"></i>导出</el-button>
                            </div>
                            <el-table :data="minData" style="width: 100%" height="300">
                                <el-table-column prop="dt" label="时间" align="center" min-width="160" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="temp" label="温度" align="center" min-width="80">
                                </el-table-column>
                                <el-table-column prop="humidity" label="湿度" align="center" min-width="80">
                                </el-table-column>
                                <el-table-column prop="radiation" label="辐射" align="center" min-width="80">
                                </el-table-column>
                                <el-table-column prop="windSpeed" label="风速" align="center" min-width="80">
                                </el-table-column>
                                <!-- <el-table-column prop="forecastTemp" label="预报温度" align="center" min-width="80">
                                </el-table-column> -->
                            </el-table>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" :offset="0"></el-col>
                </el-row>
            </el-col>

            <!-- 小时报表 -->
            <el-col :span="12" :offset="0">
                <el-row>
                    <el-col :span="24" :offset="0">
                        <el-card>
                            <div slot="header">
                                日报表
                                <el-date-picker v-model="hourTime" type="date" placeholder="选择日期" size="mini"
                                    value-format="yyyy-MM-dd" :clearable="false">
                                </el-date-picker>
                                <el-button type="primary" size="mini" style="margin-left: 10px;" @click="getHourReport"
                                    :disabled="buttonClick"><i class="el-icon-search"></i>搜索</el-button>
                                <el-button type="warning" size="mini" style="margin-left: 10px;" @click="exportHourReport"
                                    :disabled="buttonClick"><i class="el-icon-download"></i>导出</el-button>
                            </div>
                            <el-table :data="hourData" style="width: 100%" height="300">
                                <el-table-column prop="dt" label="时间" align="center" min-width="160" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="temp" label="温度" align="center" min-width="80">
                                </el-table-column>
                                <el-table-column prop="humidity" label="湿度" align="center" min-width="80">
                                </el-table-column>
                                <el-table-column prop="radiation" label="辐射" align="center" min-width="80">
                                </el-table-column>
                                <el-table-column prop="windSpeed" label="风速" align="center" min-width="80">
                                </el-table-column>
                                <!-- <el-table-column prop="forecastTemp" label="预报温度" align="center" min-width="80">
                                </el-table-column> -->
                            </el-table>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" :offset="0"></el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import * as echarts from "echarts"
import moment from "moment"
import StaGis from "@/components/StaGis.vue"
import { weaStaList, weaStaInfo, weaStaRtd, dayAvgT, minWeaData, minHis, hourHis, houHisExport } from "@/api/zqw/weather"
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        StaGis
    },
    data() {
        //这里存放数据
        return {
            options: [],
            selWsId: undefined,

            //气象站坐标
            center: { lng: 116.404, lat: 39.915 },

            dayChart: null,
            dataChart: null,

            rtdData: {},

            minData: [],
            hourData: [],

            minTime: moment(new Date()).format("YYYY-MM-DD"),
            hourTime: moment(new Date()).format("YYYY-MM-DD"),

            //定时获取站点信息标识
            timer: "",

            buttonClick: true
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        //切换气象站
        changeWsta(val) {
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                this.getRtd(val)
            }, 5000)
            this.getWstaInfo(val)
            this.getRtd(val)
            this.getDayAvgT(val)
            this.getMinChart(val)
            this.getMinReport()
            this.getHourReport()
        },

        //导出小时报表
        exportHourReport() {
            window.location.href = 'http://123.249.13.202:8085/weaSta/hourHisExport?wsId=' + this.selWsId + '&dt=' + this.hourTime
            // this.download(
            //     '/weaSta/hourHisExport?wsId=' + this.selWsId + '&dt=' + this.hourTime,
            //     {},
            //     `气象站小时均值日报表${new Date().getTime()}.xlsx`
            // )
        },
        //获取小时报表数据
        getHourReport() {
            hourHis(this.selWsId, this.hourTime).then(res => {
                this.hourData = res.data
            })
        },

        //导出分钟报表数据
        exportMinReport() {
            window.location.href = 'http://123.249.13.202:8085/weaSta/minHisExport?wsId=' + this.selWsId + '&dt=' + this.hourTime
            // this.download(
            //     '/weaSta/exportMin?wsId=' + this.selWsId + '&dt=' + this.minTime,
            //     {},
            //     `气象站分钟数据报表_${new Date().getTime()}.xlsx`
            // )
        },
        //获取分钟报表数据
        getMinReport() {
            minHis(this.selWsId, this.minTime).then(res => {
                this.minData = res.data
            })
        },

        //获取曲线数据
        getMinChart(wsId) {
            this.initDataChart()
            minWeaData(wsId).then(res => {
                if (res.data.length > 0) {
                    let dt = []
                    // let forecastTemp = []
                    let temp = []
                    let humidity = []
                    let radiation = []
                    let windSpeed = []
                    for (let i = 0; i < res.data.length; i++) {
                        dt.push(res.data[i].dt)
                        // forecastTemp.push(res.data[i].forecastTemp)
                        temp.push(res.data[i].temp)
                        humidity.push(res.data[i].humidity)
                        radiation.push(res.data[i].radiation)
                        windSpeed.push(res.data[i].windSpeed)
                    }
                    this.dataChart.setOption({
                        xAxis: {
                            data: dt
                        },
                        series: [
                            // {
                            //     name: '预报温度',
                            //     type: 'line',
                            //     data: forecastTemp
                            // },
                            {
                                name: '气象站温度',
                                type: 'line',
                                data: temp
                            },
                            {
                                name: '气象站湿度',
                                type: 'line',
                                data: humidity
                            },
                            {
                                name: '气象站辐射',
                                type: 'line',
                                data: radiation
                            },
                            {
                                name: '气象站风速',
                                type: 'line',
                                data: windSpeed
                            }
                        ]
                    })
                }
            })
        },

        //获取实时气象站信息
        getRtd(wsId) {
            weaStaRtd(wsId).then(res => {
                this.rtdData = res.data
            })
        },

        //日平均温度
        getDayAvgT(wsId) {
            this.initDayAvgChart()
            dayAvgT(wsId).then(res => {
                if (res.data.length > 0) {
                    let dts = []
                    let data = []
                    for (let index = 0; index < res.data.length; index++) {
                        dts.push(res.data[index].dt)
                        data.push(res.data[index].temp)
                    }
                    this.dayChart.setOption({
                        xAxis: {
                            data: dts
                        },
                        series: {
                            data
                        }
                    })
                }
            })
        },

        //获取气象站信息
        getWstaInfo(wsId) {
            weaStaInfo(wsId).then(res => {
                this.center = { lng: res.data.lng, lat: res.data.lat }
            })
        },

        //获取气象站集合
        getWstaList() {
            weaStaList().then(res => {
                if (res.data != null && res.data.length > 0) {
                    this.options = res.data
                    this.selWsId = res.data[0].wsId
                    this.center = { lng: res.data[0].lng, lat: res.data[0].lat }
                    this.getRtd(this.selWsId)
                    this.getDayAvgT(this.selWsId)
                    this.getMinChart(this.selWsId)
                    this.getMinReport(this.selWsId)
                    this.getHourReport(this.selWsId)

                    this.timer = setInterval(() => {
                        this.getRtd(this.selWsId)
                    }, 5000)

                    this.buttonClick = false
                }
            })
        },

        //数据曲线
        initDataChart() {
            if (this.dataChart != null && this.dataChart != "" && this.dataChart != undefined) {
                this.dataChart.dispose(); //销毁
            }
            this.dataChart = echarts.init(document.getElementById("dataChart"))
            this.dataChart.setOption({
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['气象站温度', '气象站湿度', '气象站辐射', '气象站风速'],
                    top: '-1%'
                },
                grid: {
                    left: '0%',
                    right: '1%',
                    bottom: '1%',
                    top: '10%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    // {
                    //     name: '预报温度',
                    //     type: 'line',
                    //     data: []
                    // },
                    {
                        name: '气象站温度',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '气象站湿度',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '气象站辐射',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '气象站风速',
                        type: 'line',
                        data: []
                    }
                ]
            })
        },
        //日平均温度柱形图
        initDayAvgChart() {
            if (this.dayChart != null && this.dayChart != "" && this.dayChart != undefined) {
                this.dayChart.dispose(); //销毁
            }
            this.dayChart = echarts.init(document.getElementById("dayAvgChart"))
            this.dayChart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: [],
                },
                yAxis: {
                    type: 'value'
                },
                grid: {
                    left: '0%',
                    right: '1%',
                    bottom: '3%',
                    top: "2%",
                    containLabel: true
                },
                series: [
                    {
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#83bff6' },
                                { offset: 0.5, color: '#188df0' },
                                { offset: 1, color: '#188df0' }
                            ])
                        },
                    }
                ]
            })
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getWstaList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() {
        clearInterval(this.timer)
    }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped lang="scss">
.bg {
    margin: 20px 40px;
}

.el-row {
    margin-bottom: 20px;
}

.nowBox {
    .el-card {
        height: 190px;

        .rtdBox {
            display: flex;
            align-items: center;

            img {
                height: 100px;
            }

            /* 垂直居中 */
            .rtd {
                font-size: 40px;
                // white-space: nowrap;
                /* 防止文本换行 */
                font-weight: 600;
                margin: 0 0 20px 10px;
            }

            .rtdUnit {
                font-size: 25px;
                font-weight: 600;
                margin: 0 0 10px 5px;
            }
        }
    }

}
</style>